// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"457b7250","239":"e137efb1","455":"93f95aff","952":"4e09631c"}[chunkId] + ".chunk.js";
};